import { SensorType } from "@somewear/api";

export const sensorTypes = {
	[SensorType.SENSORTYPEPOLAR]: "Polar",
	[SensorType.SENSORTYPEUNKNOWN]: "Unknown",
	[SensorType.SENSORTYPEWHOOP]: "WHOOP",
	[SensorType.SENSORTYPEZEPHYR]: "Zephyr",
};
